import React from 'react';
import classes from './Comment.module.css';

const Comment = (props) => {
  return (
    <div className={classes.comment}>
        <div className={classes.commentHeading}>
            <h4 className={classes.user}><i class="fa-solid fa-user"></i> {props?.user}</h4>
            <h4>{props?.date}</h4>
        </div>
        <h3>{props.text}</h3>
    </div>
  )
}

export default Comment;